import { ExtendedPropertyType } from '@bpd-library/utilities';
import { useTranslate } from '@utilities/hooks';

import { FormattedStatus, StatusTranslations } from '.';

/**
 * @description Takes an Extended property type and returns the translated status and color
 * @param {ExtendedPropertyType} propertyType
 * @return {*}  {(FormattedStatus | undefined)}
 */
const formatPropertyTypeStatus = (
    propertyType: ExtendedPropertyType,
): FormattedStatus | undefined => {
    const { projectPhase, constructionNumbers, status } = propertyType;

    if (!status) return;

    switch (status) {
        case 'AmountAvailable':
            const availableConstructionNumbers = constructionNumbers!.filter(
                (s) => s.availabilityStatus === 'Available',
            );

            return {
                label: useTranslate('StatusLabel-AmountAvailable', {
                    replace: [{ id: 'Amount', value: `${availableConstructionNumbers.length}` }],
                }),
                color: 'green',
            };
        case 'AssigningOn':
            const allocationDate = new Date(projectPhase?.allocationDate!).toLocaleDateString(
                window.__ENVIRONMENT_DETAILS__.languageIsoCode,
                {
                    day: 'numeric',
                    month: 'short',
                },
            );

            return {
                label: useTranslate('StatusLabel-AssigningOn.Dynamic', {
                    replace: [{ id: 'Date', value: allocationDate }],
                }),
                color: 'orange',
            };
        default:
            return StatusTranslations.FORMATTED[status];
    }
};

export { formatPropertyTypeStatus };
